<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="title_page">The Silent Strength of Stones</h1>
<h2 class="center" style="margin-top:20px;">A Chapel Hollow Novel</h2>
<h3 class="center" style="margin-top:60px;">Nina Kiriki Hoffman</h3>
<p class="center" style="margin-top:80px;"><img alt="logo" src="image/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SilentStrength.vue?c1b7fa22